import React, {useEffect, useState} from 'react'
import DHButtonSave from "../../../general/DHButtonSave";
import {TableContainer, Tooltip} from "@mui/material";
import DHDialog from "../../../general/DHDialog";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";
import DHSelect from "../../../general/DHSelect";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import DHNumberTextField from "../../../general/DHNumberTextField";

export default function ErgebnisDetailComp({liga, spiel, onRefresh}) {

    const CELL_PADDING_VALUE = 8;

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [mannschaftNameHeim, setHannschaftNameHeim] = useState("");
    const [mannschaftNameGast, setHannschaftNameGast] = useState("");

    const [games, setGames] = useState([]);
    const [playersHeim, setPlayersHeim] = useState([]);
    const [playersGast, setPlayersGast] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [working, setWorking] = useState(false);


    useEffect(() => {
        if (!showDialog) {
            return;
        }
        ladeDetailDaten();
    }, [showDialog]);

    const ladeDetailDaten = () => {
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.league + "/liga/spiel/infos/" + spiel.id,
            {},
            (dto) => {
                setPlayersHeim(dto.heimSpieler);
                setPlayersGast(dto.gastSpieler);
                setGames(dto.games);
                setHannschaftNameHeim(dto.mannschaftNameHeim);
                setHannschaftNameGast(dto.mannschaftNameGast);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden! " + responseNotOk.message)
            },
            error => {
                setErrorMessage("Fehler beim Laden! " + error.message)
            }
        );
    }


    const validateData = () => {
        for (const game of games) {
            if( (game.anzahlPlayer1 !== undefined && game.anzahlPlayer2 === undefined) || (game.anzahlPlayer1 === undefined && game.anzahlPlayer2 !== undefined)) {
                setErrorMessage("Sobald ein Leg Feld am Spiel gesetzt ist, müssen beide gesetzt sein.");
                return false;
            }
            if( game.anzahlPlayer1 ) {
                // spieler müssen gesetzt sein.
                if( game.type === "EZ" && (!game.player1Id || !game.player2Id)) {
                    setErrorMessage("Sobald ein Leg Feld am Spiel gesetzt ist, müssen die Spieler gesetzt werden.");
                    return false;
                } else if( game.type === "DP" && (!game.doppelpartner1Player1Id || !game.doppelpartner1Player2Id ||
                    !game.doppelpartner2Player1Id || !game.doppelpartner2Player2Id)) {
                    setErrorMessage("Sobald ein Leg Feld am Spiel gesetzt ist, müssen die Spieler gesetzt werden.");
                    return false;
                }
            }
        }
        return true;
    }

    const save = () => {
        setErrorMessage(undefined);
        let valid = validateData();
        if( valid) {
            FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.league + "/liga/spiel/ergebnis/detail/save/" + spiel.id,
                games,
                () => {
                    setInfoMessage("Speichern war erfolgreich!")
                    onRefresh();
                },
                responseNotOk => {
                    setErrorMessage("Fehler beim Speichern! " + responseNotOk.message)
                },
                error => {
                    setErrorMessage("Fehler beim Speichern! " + error.message)
                }
            );
        }

    }

    const changePlayer = (spielNr, playerNr, type, value) => {
        let game = games.filter(game => game.counter === spielNr)[0];
        if (game.type === "EZ" && playerNr === 1 && type === "HEIM") {
            game = {...game, player1Id: value};
        } else if (game.type === "EZ" && playerNr === 1 && type === "GAST") {
            game = {...game, player2Id: value};
        } else if (game.type === "DP" && playerNr === 1 && type === "HEIM") {
            game = {...game, doppelpartner1Player1Id: value};
        } else if (game.type === "DP" && playerNr === 2 && type === "HEIM") {
            game = {...game, doppelpartner1Player2Id: value};
        } else if (game.type === "DP" && playerNr === 1 && type === "GAST") {
            game = {...game, doppelpartner2Player1Id: value};
        } else if (game.type === "DP" && playerNr === 2 && type === "GAST") {
            game = {...game, doppelpartner2Player2Id: value};
        }
        let newGames = games.filter(game => game.counter !== spielNr);
        newGames.push(game);
        setGames(newGames);
    }

    const getPlayerValue = (spielNr, playerNr, type) => {
        if (games.length === 0) {
            // daten sind noch nicht geladen
            return undefined;
        }
        let playerId = undefined;
        let game = games.filter(game => game.counter === spielNr)[0];
        if (game.type === "EZ" && playerNr === 1 && type === "HEIM") {
            playerId = game.player1Id;
        } else if (game.type === "EZ" && playerNr === 1 && type === "GAST") {
            playerId = game.player2Id;
        } else if (game.type === "DP" && playerNr === 1 && type === "HEIM") {
            playerId = game.doppelpartner1Player1Id;
        } else if (game.type === "DP" && playerNr === 2 && type === "HEIM") {
            playerId = game.doppelpartner1Player2Id;
        } else if (game.type === "DP" && playerNr === 1 && type === "GAST") {
            playerId = game.doppelpartner2Player1Id;
        } else if (game.type === "DP" && playerNr === 2 && type === "GAST") {
            playerId = game.doppelpartner2Player2Id;
        }

        if (playerId) {
            let tmp = playersHeim.filter(t => t.id === playerId);
            if (tmp.length === 1) {
                return tmp[0].id;
            }
            tmp = playersGast.filter(t => t.id === playerId);
            if (tmp.length === 1) {
                return tmp[0].id;
            }
        }
        return undefined;
    }

    const getTable = () => {
        return <TableContainer style={{maxHeight: "100%", paddingBottom: 0}}>
            <Table stickyHeader style={{backgroundColor: "#022836", color: "white", fontSize: 12}}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{backgroundColor: "#ac1c27", color: "white", fontSize: 12, width: 10, padding: CELL_PADDING_VALUE}}>Spiel</TableCell>
                        <TableCell style={{backgroundColor: "#ac1c27", color: "white", fontSize: 12, padding: CELL_PADDING_VALUE}}>{mannschaftNameHeim}</TableCell>
                        <TableCell style={{backgroundColor: "#ac1c27", color: "white", fontSize: 12, padding: CELL_PADDING_VALUE}}>{mannschaftNameGast}</TableCell>
                        <TableCell style={{backgroundColor: "#ac1c27", color: "white", fontSize: 12, width: 100, padding: CELL_PADDING_VALUE}}>Legs</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {getTableRows()}
                </TableBody>
            </Table>
        </TableContainer>
    }

    const getTableRows = () => {
        if (liga.modusId === undefined) {
            return [];
        }
        let styleWithBackground = {color: "#022836", background: "#eaf1f5", fontSize: 18, padding: CELL_PADDING_VALUE};
        let styleWithoutBackground = {color: "#022836", background: "white", fontSize: 18, padding: CELL_PADDING_VALUE};
        let background = false;
        let rows = [];
        let spielNr = 1;
        let array = liga.modusId.split("|");
        let bereichCounter = 0;
        for (const element of array) {
            bereichCounter++;
            let row = element.split("x");
            let anzahl = parseInt(row[0]);
            let type = row[1];
            let blockLabel = getBlockLabel(bereichCounter, anzahl, type);
            rows.push(getBlockTableRow(bereichCounter, blockLabel))

            for (let i = 0; i < anzahl; i++) {
                let style = background ? styleWithBackground : styleWithoutBackground;
                if (type === "EZ") {
                    rows.push(getEZTableRow(spielNr, style));
                } else if (type === "DP") {
                    rows.push(getDPTableRow(spielNr, style));
                }
                spielNr++;
            }
        }
        return rows
    }

    const getPlayerSelectionValues = (players) => {
        let values = [];
        for (const player of players) {
            values.push({
                id: player.id, value: <div style={{textAlign: "left"}}>
                    <div>{player.name + ", " + player.vorname}</div>
                    <div style={{marginTop: 5, fontSize: 10}}>Spielernummer: {player.spielernummer}</div>
                </div>
            });
        }
        return values;
    }

    const changeAnzahl = (spielNr, type, value) => {
        let game = games.filter(game => game.counter === spielNr)[0];
        if (type === "HEIM") {
            game = {...game, anzahlPlayer1: value};
        } else {
            game = {...game, anzahlPlayer2: value};
        }
        let newGames = games.filter(game => game.counter !== spielNr);
        newGames.push(game);
        setGames(newGames);
    }

    const getBlockTableRow = (block, label) => {
        return <TableRow key={"key_block_" + block}>
            <TableCell colSpan={4} style={{backgroundColor: "#ac1c27", color: "white"}}>{label}</TableCell>
        </TableRow>
    }

    const getErgebnisColum = (spielNr, style) => {
        if (games.length === 0) {
            // daten sind noch nicht geladen
            return <TableCell style={style}>-</TableCell>;
        }
        let game = games.filter(game => game.counter === spielNr)[0];
        return <TableCell style={style}>
                <span style={{marginRight: 10}}>
                    <DHNumberTextField width={30} variant="standard" value={game.anzahlPlayer1} onChange={(value) => changeAnzahl(spielNr, "HEIM", value)} min={0}/>
                </span>
            <DHNumberTextField width={30} variant="standard" value={game.anzahlPlayer2} onChange={(value) => changeAnzahl(spielNr, "GAST", value)} min={0}/>
        </TableCell>

    }

    const getEZTableRow = (spielNr, style) => {
        return <TableRow key={"key_game_" + spielNr}>
            <TableCell style={style}>{spielNr}.</TableCell>
            <TableCell style={style}>
                <DHSelect value={getPlayerValue(spielNr, 1, "HEIM")}
                          model={getPlayerSelectionValues(playersHeim)} width={"100%"}
                          smallSize={true}
                          onChange={(value) => changePlayer(spielNr, 1, "HEIM", value)}/>
            </TableCell>
            <TableCell style={style}>
                <DHSelect value={getPlayerValue(spielNr, 1, "GAST")}
                          model={getPlayerSelectionValues(playersGast)} width={"100%"}
                          smallSize={true}
                          onChange={(value) => changePlayer(spielNr, 1, "GAST", value)}/>
            </TableCell>
            {getErgebnisColum(spielNr, style)}
        </TableRow>
    }

    const getDPTableRow = (spielNr, style) => {
        return <TableRow key={"key_game_" + spielNr}>
            <TableCell style={style}>{spielNr}.</TableCell>
            <TableCell style={style}>
                <DHSelect value={getPlayerValue(spielNr, 1, "HEIM")}
                          model={getPlayerSelectionValues(playersHeim)} width={"100%"}
                          smallSize={true}
                          onChange={(value) => changePlayer(spielNr, 1, "HEIM", value)}/>
                <DHSelect value={getPlayerValue(spielNr, 2, "HEIM")}
                          model={getPlayerSelectionValues(playersHeim)} width={"100%"}
                          smallSize={true}
                          onChange={(value) => changePlayer(spielNr, 2, "HEIM", value)}/>
            </TableCell>
            <TableCell style={style}>
                <DHSelect value={getPlayerValue(spielNr, 1, "GAST")}
                          model={getPlayerSelectionValues(playersGast)} width={"100%"}
                          smallSize={true}
                          onChange={(value) => changePlayer(spielNr, 1, "GAST", value)}/>
                <DHSelect value={getPlayerValue(spielNr, 2, "GAST")}
                          model={getPlayerSelectionValues(playersGast)} width={"100%"}
                          smallSize={true}
                          onChange={(value) => changePlayer(spielNr, 2, "GAST", value)}/>
            </TableCell>
            {getErgebnisColum(spielNr, style)}
        </TableRow>
    }

    const getBlockLabel = (counter, anzahl, type) => {

        let typBezeichnung = "";
        if (type === "EZ") {
            typBezeichnung = "Einzel";
        } else if (type === "DP") {
            typBezeichnung = "Doppel";
        } else if (type === "TG") {
            typBezeichnung = "Teamgame";
        }
        return counter + ". Block - " + anzahl + " " + typBezeichnung;
    }

    return <>
        <Tooltip title="Detailerfassung - Ergebnis eintragen/ändern">
            <CreditScoreIcon style={{marginRight: 10, cursor: "pointer"}} onClick={() => setShowDialog(true)}/>
        </Tooltip>
        {showDialog && <DHDialog showCloseButton={true} title="Detailerfassung - Ergebnis eintragen/ändern" onClose={() => setShowDialog(false)}
                                 buttons={
                                     [<DHButtonSave working={working} onClick={() => save()} disabled={false}/>]}
                                 comp={<>
                                     <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                                         onClearErrorMessage={() => setErrorMessage(undefined)}/>
                                     {getTable()}
                                 </>}/>
        }
    </>
}